export const numberLayer = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
  { value: 6, text: '6' },
  { value: 8, text: '8' },
  { value: 10, text: '10' },
];

export const materialType = [
  { value: 'FR4', text: 'FR4 Tg135' },
  { value: 'FR4TG170', text: 'FR4 Tg170' },
  { value: 'FR4TG180', text: 'FR4 Tg180' },
];

export const materialThickness = [
  { value: '0.125', text: '0.125"' },
  { value: '0.093', text: '0.093"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.047', text: '0.047"' },
  { value: '0.040', text: '0.040"' },
  { value: '0.031', text: '0.031"' },
  { value: '0.020', text: '0.020"' },
  { value: '0.014', text: '0.014"' },
  { value: '0.010', text: '0.010"' },
  { value: 'Other', text: 'Other' },
];

export const finishPlating = [
  { value: 'Leaded Solder', text: 'Leaded Solder' },
  { value: 'Lead Free Solder', text: 'Lead Free Solder' },
  { value: 'Bare Copper', text: 'Bare Copper' },
  // {value: 'Immersion Gold', text: 'Immersion Gold'},
  { value: 'ENIG', text: 'ENIG' },
  { value: 'OSP', text: 'OSP' },
  { value: 'Carbon Ink', text: 'Carbon Ink' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
  { value: 'Immersion Tin', text: 'Immersion Tin' },
  { value: 'Peelable Mask', text: 'Peelable Mask' },
];

export const cooperInner = [
  { value: '0.5 oz', text: '0.5 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
  { value: '4 oz', text: '4 oz' },
];

export const cooperOuter = [
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
  { value: '4 oz', text: '4 oz' },
];

export const solderSide = [
  { value: 'Top Side', text: 'Top Side' },
  { value: 'Both Sides', text: 'Both Sides' },
  { value: 'Bottom Side', text: 'Bottom Side' },
  { value: 'None', text: 'None' },
];

export const solderColor = [
  { value: 'green', text: 'Green' },
  { value: 'Matte Green', text: 'Matte Green' },
  { value: 'Black', text: 'Glossy Black' },
  { value: 'Blue', text: 'Blue' },
  { value: 'Clear', text: 'Clear' },
  { value: 'Red', text: 'Red' },
  { value: 'White', text: 'White' },
  { value: 'Matte Black', text: 'Matte Black' },
];

export const stencilSide = [
  { value: '', text: 'Select One' },
  { value: 'Top Side', text: 'Top Side' },
  { value: 'Bottom Side', text: 'Bottom Side' },
  { value: 'Combine Top & Bottom', text: 'Combine Top & Bottom' },
];

export const silkscreenSide = [
  { value: 'Top Side', text: 'Top Side' },
  { value: 'Both Sides', text: 'Both Sides' },
  { value: 'Bottom Side', text: 'Bottom Side' },
  { value: 'None', text: 'None' },
];

export const silkscreenColor = [
  { value: 'White', text: 'White' },
  { value: 'Black', text: 'Black' },
  { value: 'Yellow', text: 'Yellow' },
  { value: 'Grey', text: 'Grey' },
];

export const MinTrace = [
  { value: '0.012', text: '0.012"' },
  { value: '0.01', text: '0.01"' },
  { value: '0.008', text: '0.008"' },
  { value: '0.007', text: '0.007"' },
  { value: '0.006', text: '0.006"' },
  { value: '0.005', text: '0.005"' },
  { value: '0.004', text: '0.004"' },
  { value: '0.0035', text: '0.0035"' },
];

export const goldThickness = [
  { value: 'Au<10', text: 'Au < 10u"' },
  { value: '11<Au<20', text: '11u" < Au < 20u"' },
  { value: '21<Au<30', text: '21u" < Au < 30u"' },
  { value: '31<Au<39', text: '31u" < Au < 39u"' },
  { value: '40<Au<50', text: '40u" < Au < 50u"' },
  { value: '51<Au<120', text: '51u" < Au < 120u"' },
];

export const pitch = [
  { value: '0.0', text: 'n/a' },
  { value: '0.05', text: '0.05"' },
  { value: '0.025', text: '0.025"' },
  { value: '0.015', text: '0.015"' },
  { value: '0.01', text: '0.01"' },
];

export const minTraceSpace = [
  { value: '0.012', text: '0.012"' },
  { value: '0.01', text: '0.01"' },
  { value: '0.008', text: '0.008"' },
  { value: '0.007', text: '0.007"' },
  { value: '0.006', text: '0.006"' },
  { value: '0.005', text: '0.005"' },
  { value: '0.004', text: '0.004"' },
  { value: '0.0035', text: '0.0035"' },
];

export const blindBuriedHole = [
  { value: 'None', text: 'None' },
  { value: '2 drilling process', text: '2 drilling process' },
  { value: '3 drilling process', text: '3 drilling process' },
  { value: '4 drilling process', text: '4 drilling process' },
  { value: '5 drilling process', text: '5 drilling process' },
];

export const printConfirmation = [
  { value: '', text: 'Select One' },
  { value: '0', text: 'No' },
  { value: '1', text: 'Yes' },
];

export const numberDesigns = [
  { value: 1, text: '1' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5' },
];

export const viaFill = [
  { value: 'none', text: 'None' },
  { value: 'resin', text: 'Resin (Non-Conductive)' },
  { value: 'copper', text: 'Copper (Conductive)' },
];

export const spacingTabRouted = [
  { value: '', text: 'Select One' },
  { value: '0.050', text: '0.050"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.093', text: '0.093"' },
  { value: '0.200', text: '0.200"' },
];

export const spacingVScored = [
  { value: '', text: 'Select One' },
  { value: '0.000', text: '0.000"' },
  { value: '0.200', text: '0.200"' },
];


export const stencilFiducialData = [
  { value: '', text: 'Select One' },
  { value: 'Delete fiducials/No fiducials', text: 'Delete fiducials/No fiducials' },
  { value: 'Etched Through', text: 'Etched Through' },
  { value: '1/2 Etched on Board Side', text: '1/2 Etched on Board Side' },
  { value: '1/2 Etched on Squeegee Side', text: '1/2 Etched on Squeegee Side' },
];

export const stencilsThickness = [
  { value: '', text: 'Select One' },
  { value: 'Select For Me', text: 'Select For Me' },
  { value: '0.002', text: '0.002' },
  { value: '0.003', text: '0.003' },
  { value: '0.004', text: '0.004' },
  { value: '0.005', text: '0.005' },
  { value: '0.006', text: '0.006' },
  { value: '0.007', text: '0.007' },
  { value: '0.008', text: '0.008' },
  { value: '0.010', text: '0.010' },
  { value: '0.012', text: '0.012' },
  { value: '0.015', text: '0.015' },
]